import React, { useEffect } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { useHandleOktaLogin, oktaAuthHandler } from '@choreograph/authjs'

import { KeyUserIcon, WppLayout, WppRoutesComponent } from './packages/wpplayout'
import { selectUser, setUser, setPermission } from './state/slices/appSlice'
import { UserListContainer } from './components/users'
import { PermissionManagerHeader } from './components/PermissionManagerHeaderComponent'

import './app.scss'

const appRoutes = [
  { path: '/', element: <Navigate to='/users' /> },
  { path: '/users', element: <UserListContainer /> },
  { path: '/users/:userId', element: <UserListContainer /> }
]
const oktaRoutes = [
  oktaAuthHandler.paths.callback,
  oktaAuthHandler.paths.forbidden,
  oktaAuthHandler.paths.login
]

const App = () => {
  const dispatch = useDispatch()
  const user = useSelector(selectUser)
  const isAuthChecked = useHandleOktaLogin(oktaAuthHandler)
  const { pathname } = useLocation()

  useEffect(() => {
    const getUser = async () => {
      const usr = await oktaAuthHandler.getUser()
      const canCheckPermissions = await oktaAuthHandler
        .checkPermission({ resourceType: 'auth/spicedb', resourceId: 'auth', permission: 'check_permission' })

      dispatch(setUser(usr))
      dispatch(setPermission(canCheckPermissions))
    }
    /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
    !oktaRoutes.includes(pathname) && isAuthChecked && getUser()
  }, [dispatch, pathname, isAuthChecked])

  if (!isAuthChecked) {
    return <>Loading...</>
  }

  return (
    <WppLayout
      appName='Permission Manager'
      extraClassName='permission-manager'
      appReady={true}
      appLogo={<KeyUserIcon />}
      headerExtraContent={
        <PermissionManagerHeader user={user} logout={async () => {
          const currentUrl = window.location.href
          const logoutUrl = process.env.OKTA_LOGOUT_URL +
            '?post_logout_redirect_uri=' + encodeURIComponent(currentUrl)
          window.location.href = logoutUrl
          await oktaAuthHandler.logout()
        }} />
      }
    >
      <WppRoutesComponent routes={appRoutes} />
    </WppLayout>
  )
}

export default App
